/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_OutboxInputs */

const en_scene_outside_outbox = /** @type {(inputs: Scene_Outside_OutboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbox`)
};

/**
* | output |
* | --- |
* | "Outbox" |
*
* @param {Scene_Outside_OutboxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_outbox = /** @type {((inputs?: Scene_Outside_OutboxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_OutboxInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_outbox(inputs)
});